
import { Injectable } from '@angular/core';
import { CommsService } from '@acaprojects/ngx-composer';

import { BaseService } from '../base.service';
import { ICateringMenuItem } from "../models/interfaces";





@Injectable({
    providedIn: 'root'
})
export class CateringCategoriesService extends BaseService<ICateringMenuItem> {

    constructor(protected http: CommsService) {
        super();
        this.model.name = 'catering category/group';
        this.model.route = '/catering/category';
    }

    public query(): never {
        throw Error('No index endpoint for catering categories. Use catering menu service.');
    }

    public show(): never {
        throw Error('No show endpoint for catering categories. Use catering menu service.');
    }

    public format(raw: any) {
        const formatted = {
            ...raw,
            image_path: raw.src,
            parent_categories: raw.parent_categories || raw.parent,
            minimum_quantity: raw.minimum || raw.minimum_quantity,
            maximum_quantity: raw.maximum || raw.maximum_quantity
        };
        delete formatted.minimum;
        delete formatted.maximum;
        return formatted;
    }
}